interface Props {
  estiloPersonal: string;
  setEstiloPersonal: (v: string) => void;
  notasEstilista: string;
  setNotasEstilista: (v: string) => void;
}

export default function EstiloNotasSection({ estiloPersonal, setEstiloPersonal, notasEstilista, setNotasEstilista }: Props) {
  return (
    <>
      {/* Estilo personal */}
      <div className="bg-white border border-brand-gray-200 rounded-2xl p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-full bg-brand-sage/20 flex items-center justify-center text-brand-black">
            <i className="ri-sparkling-line text-lg" />
          </div>
          <div>
            <h3 className="font-serif text-brand-black text-lg font-medium">Estilo personal</h3>
            <p className="font-sans text-brand-gray-500 text-xs mt-0.5">
              Describe la personalidad de estilo de este cliente
            </p>
          </div>
        </div>
        <textarea
          value={estiloPersonal}
          onChange={(e) => setEstiloPersonal(e.target.value)}
          rows={4}
          placeholder="Ej: Elegante casual con toques clásicos..."
          className="w-full border border-brand-gray-200 rounded-lg px-3 py-2.5 font-sans text-sm focus:outline-none focus:border-brand-black resize-none"
        />
      </div>

      {/* Notas del estilista */}
      <div className="bg-white border border-brand-gray-200 rounded-2xl p-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-full bg-brand-black flex items-center justify-center text-white">
            <i className="ri-quill-pen-line text-lg" />
          </div>
          <div>
            <h3 className="font-serif text-brand-black text-lg font-medium">Notas del estilista</h3>
            <p className="font-sans text-brand-gray-500 text-xs mt-0.5">
              Observaciones privadas para recordar detalles clave
            </p>
          </div>
        </div>
        <textarea
          value={notasEstilista}
          onChange={(e) => setNotasEstilista(e.target.value)}
          rows={5}
          placeholder="Ej: Prefiere cuello alto, evita texturas ásperas..."
          className="w-full border border-brand-gray-200 rounded-lg px-3 py-2.5 font-sans text-sm focus:outline-none focus:border-brand-black resize-none"
        />
      </div>
    </>
  );
}